function ___$insertStyle(css) {
  if (!css) {
    return;
  }

  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');
  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopDefault(ex) {
  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}

var React = _interopDefault(require('react'));

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

___$insertStyle(".datalist-input {\n  /*the container must be positioned relative:*/\n  position: relative;\n  display: inline-block;\n  width: 100%;\n}\n\n.datalist-input .autocomplete-input {\n  width: 100%;\n}\n\n.datalist-input .datalist-items {\n  position: absolute;\n  z-index: 99;\n  /*position the autocomplete items to be the same width as the container:*/\n  top: 100%;\n  left: 0;\n  right: 0;\n}\n\n.datalist-input .default-datalist-items {\n  border: 1px solid #d4d4d4;\n  border-bottom: none;\n  border-top: none;\n}\n\n.datalist-input .default-datalist-items div:not(.datalist-active-item) {\n  padding: 10px;\n  cursor: pointer;\n  background-color: #fff;\n  border-bottom: 1px solid #d4d4d4;\n}\n\n.datalist-input .default-datalist-items div:not(.datalist-active-item):hover {\n  /*when hovering an item:*/\n  background-color: #e9e9e9;\n}\n\n.datalist-input .datalist-active-item {\n  /*when navigating through the items using the arrow keys:*/\n  cursor: pointer;\n}\n\n.datalist-input .datalist-active-item-default {\n  background-color: DodgerBlue;\n  color: #ffffff;\n  border-bottom: 1px solid #d4d4d4;\n  padding: 10px;\n}");

var DataListInput = /*#__PURE__*/function (_React$Component) {
  _inherits(DataListInput, _React$Component);

  var _super = _createSuper(DataListInput);

  function DataListInput(props) {
    var _this;

    _classCallCheck(this, DataListInput);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      if (typeof window !== 'undefined') {
        window.addEventListener('click', _this.onClickCloseMenu, false);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function () {
      var _this$state = _this.state,
          currentInput = _this$state.currentInput,
          visible = _this$state.visible,
          isMatchingDebounced = _this$state.isMatchingDebounced;
      var initialValue = _this.props.initialValue; // if we have an initialValue, we want to reset it everytime we update and are empty
      // also setting a new initialValue will trigger this

      if (!currentInput && initialValue && !visible && !isMatchingDebounced) {
        _this.setState({
          currentInput: initialValue
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      if (typeof window !== 'undefined') {
        window.removeEventListener('click', _this.onClickCloseMenu);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onClickCloseMenu", function (event) {
      var menu = document.getElementsByClassName('datalist-items');
      if (!menu || !menu.length) return; // if rerender, items inside might change, allow one click without further checking

      var interactionHappened = _this.state.interactionHappened;

      if (interactionHappened) {
        _this.setState({
          interactionHappened: false
        });

        return;
      } // do not do anything if input is clicked, as we have a dedicated func for that


      var input = document.getElementsByClassName('autocomplete-input');
      if (!input) return;

      for (var i = 0; i < input.length; i += 1) {
        var targetIsInput = event.target === input[i];
        var targetInInput = input[i].contains(event.target);
        if (targetIsInput || targetInInput) return;
      } // do not close menu if user clicked inside


      for (var _i = 0; _i < menu.length; _i += 1) {
        var targetInMenu = menu[_i].contains(event.target);

        var targetIsMenu = event.target === menu[_i];
        if (targetInMenu || targetIsMenu) return;
      }

      var visible = _this.state.visible;
      var onDropdownClose = _this.props.onDropdownClose;

      if (visible) {
        _this.setState({
          visible: false,
          focusIndex: -1
        }, onDropdownClose);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "match", function (currentInput, item) {
      return item.label.substr(0, currentInput.length).toUpperCase() === currentInput.toUpperCase();
    });

    _defineProperty(_assertThisInitialized(_this), "matching", function (currentInput, items, match) {
      return items.filter(function (item) {
        if (_typeof(match) === (typeof Function === "undefined" ? "undefined" : _typeof(Function))) {
          return match(currentInput, item);
        }

        return _this.match(currentInput, item);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "indexOfMatch", function (currentInput, item) {
      return item.label.toUpperCase().indexOf(currentInput.toUpperCase());
    });

    _defineProperty(_assertThisInitialized(_this), "indexOfItem", function (item, items) {
      return items.indexOf(items.find(function (i) {
        return i.key === item.key;
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "debouncedMatchingUpdateStep", function (currentInput) {
      var lastValidItem = _this.state.lastValidItem;
      var _this$props = _this.props,
          items = _this$props.items,
          match = _this$props.match,
          debounceTime = _this$props.debounceTime,
          dropDownLength = _this$props.dropDownLength,
          requiredInputLength = _this$props.requiredInputLength,
          clearInputOnSelect = _this$props.clearInputOnSelect,
          onDropdownOpen = _this$props.onDropdownOpen,
          onDropdownClose = _this$props.onDropdownClose; // cleanup waiting update step && be ssr safe

      if (_this.inputHappenedTimeout && typeof window !== 'undefined') {
        window.clearTimeout(_this.inputHappenedTimeout);
        _this.inputHappenedTimeout = null;
      } // set currentInput into input field and show loading if debounced mode is on


      var reachedRequiredLength = currentInput.length >= requiredInputLength;
      var showMatchingStillLoading = debounceTime >= 0 && reachedRequiredLength;

      _this.setState({
        currentInput: currentInput,
        isMatchingDebounced: showMatchingStillLoading
      }); // no matching if we do not reach required input length


      if (!reachedRequiredLength) return;

      var updateMatchingItems = function updateMatchingItems() {
        var matchingItems = _this.matching(currentInput, items, match);

        var displayableItems = matchingItems.slice(0, dropDownLength);
        var showDragIndex = lastValidItem && !clearInputOnSelect;
        var index = showDragIndex ? _this.indexOfItem(lastValidItem, displayableItems) : 0;

        if (matchingItems.length > 0) {
          _this.setState({
            matchingItems: displayableItems,
            focusIndex: index > 0 ? index : 0,
            visible: true,
            isMatchingDebounced: false
          }, onDropdownOpen);
        } else {
          _this.setState({
            matchingItems: displayableItems,
            visible: false,
            focusIndex: -1,
            isMatchingDebounced: false
          }, onDropdownClose);
        }
      };

      if (debounceTime <= 0) {
        updateMatchingItems();
      } else {
        if (typeof window !== 'undefined') {
          _this.inputHappenedTimeout = window.setTimeout(updateMatchingItems, debounceTime);
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onHandleInput", function (event) {
      var onInput = _this.props.onInput;
      var currentInput = event.target.value;

      _this.debouncedMatchingUpdateStep(currentInput);

      onInput(currentInput);
    });

    _defineProperty(_assertThisInitialized(_this), "onClickInput", function () {
      var visible = _this.state.visible;
      var currentInput = _this.state.currentInput;
      var _this$props2 = _this.props,
          requiredInputLength = _this$props2.requiredInputLength,
          initialValue = _this$props2.initialValue; // if user clicks on input field with initialValue,
      // the user most likely wants to clear the input field

      if (initialValue && currentInput === initialValue) {
        _this.setState({
          currentInput: ''
        });

        currentInput = '';
      }

      var reachedRequiredLength = currentInput.length >= requiredInputLength;

      if (reachedRequiredLength && !visible) {
        _this.debouncedMatchingUpdateStep(currentInput);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onHandleKeydown", function (event) {
      var _this$state2 = _this.state,
          visible = _this$state2.visible,
          focusIndex = _this$state2.focusIndex,
          matchingItems = _this$state2.matchingItems; // only do something if drop-down div is visible

      if (!visible) return;
      var currentFocusIndex = focusIndex;

      if (event.keyCode === 40 || event.keyCode === 9) {
        // If the arrow DOWN key or tab is pressed increase the currentFocus variable:
        currentFocusIndex += 1;
        if (currentFocusIndex >= matchingItems.length) currentFocusIndex = 0;

        _this.setState({
          focusIndex: currentFocusIndex
        }); // prevent tab to jump to the next input field if drop down is still open


        event.preventDefault();
      } else if (event.keyCode === 38) {
        // If the arrow UP key is pressed, decrease the currentFocus variable:
        currentFocusIndex -= 1;
        if (currentFocusIndex <= -1) currentFocusIndex = matchingItems.length - 1;

        _this.setState({
          focusIndex: currentFocusIndex
        });
      } else if (event.keyCode === 13) {
        // Enter pressed, similar to onClickItem
        if (focusIndex > -1) {
          // Simulate a click on the "active" item:
          var selectedItem = matchingItems[currentFocusIndex];

          _this.onSelect(selectedItem);
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onClickItem", function (event) {
      var matchingItems = _this.state.matchingItems; // update the input value and close the dropdown again

      var elements = event.currentTarget.children;
      var selectedKey;

      for (var i = 0; i < elements.length; i += 1) {
        if (elements[i].tagName === 'INPUT') {
          selectedKey = elements[i].value;
          break;
        }
      } // key can either be number or string
      // eslint-disable-next-line eqeqeq


      var selectedItem = matchingItems.find(function (item) {
        return item.key == selectedKey;
      });

      _this.onSelect(selectedItem);
    });

    _defineProperty(_assertThisInitialized(_this), "onSelect", function (selectedItem) {
      var _this$props3 = _this.props,
          suppressReselect = _this$props3.suppressReselect,
          clearInputOnSelect = _this$props3.clearInputOnSelect,
          onDropdownClose = _this$props3.onDropdownClose;
      var _this$state3 = _this.state,
          lastValidItem = _this$state3.lastValidItem,
          isMatchingDebounced = _this$state3.isMatchingDebounced; // block select call until last matching went through

      if (isMatchingDebounced) return;

      if (suppressReselect && lastValidItem && selectedItem.key === lastValidItem.key) {
        // do not trigger the callback function
        // but still change state to fit new selection
        _this.setState({
          currentInput: clearInputOnSelect ? '' : selectedItem.label,
          visible: false,
          focusIndex: -1,
          interactionHappened: true
        }, onDropdownClose);

        return;
      } // change state to fit new selection


      _this.setState({
        currentInput: clearInputOnSelect ? '' : selectedItem.label,
        lastValidItem: selectedItem,
        visible: false,
        focusIndex: -1,
        interactionHappened: true
      }, onDropdownClose); // callback function onSelect


      var onSelect = _this.props.onSelect;
      onSelect(selectedItem);
    });

    _defineProperty(_assertThisInitialized(_this), "renderMatchingLabel", function (currentInput, item, indexOfMatch) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, item.label.substr(0, indexOfMatch), /*#__PURE__*/React.createElement("strong", null, item.label.substr(indexOfMatch, currentInput.length)), item.label.substr(indexOfMatch + currentInput.length, item.label.length));
    });

    _defineProperty(_assertThisInitialized(_this), "renderItemLabel", function (currentInput, item, indexOfMatch) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, indexOfMatch >= 0 && currentInput.length ? _this.renderMatchingLabel(currentInput, item, indexOfMatch) : item.label);
    });

    _defineProperty(_assertThisInitialized(_this), "renderItems", function (currentInput, items, focusIndex, activeItemClassName, itemClassName, dropdownClassName) {
      return /*#__PURE__*/React.createElement("div", {
        className: "datalist-items ".concat(dropdownClassName || 'default-datalist-items')
      }, items.map(function (item, i) {
        var isActive = focusIndex === i;
        var itemActiveClasses = isActive ? "datalist-active-item ".concat(activeItemClassName || 'datalist-active-item-default') : '';
        var itemClasses = "".concat(itemClassName, " ").concat(itemActiveClasses);
        return /*#__PURE__*/React.createElement("div", {
          onClick: _this.onClickItem,
          className: itemClasses,
          key: item.key,
          tabIndex: 0,
          role: "button",
          onKeyUp: function onKeyUp(event) {
            return event.preventDefault();
          }
        }, _this.renderItemLabel(currentInput, item, _this.indexOfMatch(currentInput, item)), /*#__PURE__*/React.createElement("input", {
          type: "hidden",
          value: item.key,
          readOnly: true
        }));
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "renderLoader", function (debounceLoader, dropdownClassName, itemClassName) {
      return /*#__PURE__*/React.createElement("div", {
        className: "datalist-items ".concat(dropdownClassName || 'default-datalist-items')
      }, /*#__PURE__*/React.createElement("div", {
        className: itemClassName
      }, debounceLoader || 'loading...'));
    });

    _defineProperty(_assertThisInitialized(_this), "renderInputField", function (placeholder, currentInput, inputClassName) {
      return /*#__PURE__*/React.createElement("input", {
        onChange: _this.onHandleInput,
        onClick: _this.onClickInput,
        onKeyDown: _this.onHandleKeydown,
        type: "text",
        className: "autocomplete-input ".concat(inputClassName),
        placeholder: placeholder,
        value: currentInput
      });
    });

    var _initialValue = _this.props.initialValue;
    _this.state = {
      /*  last valid item that was selected from the drop down menu */
      lastValidItem: undefined,

      /* current input text */
      currentInput: _initialValue,

      /* current set of matching items */
      matchingItems: [],

      /* visibility property of the drop down menu */
      visible: false,

      /* index of the currently focused item in the drop down menu */
      focusIndex: 0,

      /* cleaner click events, click interaction within dropdown menu */
      interactionHappened: false,

      /* show loader if still matching in debounced mode */
      isMatchingDebounced: false
    };
    /* to manage debouncing of matching, typing input into the input field */

    _this.inputHappenedTimeout = undefined;
    return _this;
  }

  _createClass(DataListInput, [{
    key: "render",
    value: function render() {
      var _this$state4 = this.state,
          currentInput = _this$state4.currentInput,
          matchingItems = _this$state4.matchingItems,
          focusIndex = _this$state4.focusIndex,
          visible = _this$state4.visible,
          isMatchingDebounced = _this$state4.isMatchingDebounced;
      var _this$props4 = this.props,
          placeholder = _this$props4.placeholder,
          inputClassName = _this$props4.inputClassName,
          activeItemClassName = _this$props4.activeItemClassName,
          itemClassName = _this$props4.itemClassName,
          requiredInputLength = _this$props4.requiredInputLength,
          dropdownClassName = _this$props4.dropdownClassName,
          debounceLoader = _this$props4.debounceLoader;
      var reachedRequiredLength = currentInput.length >= requiredInputLength;
      var renderedResults;

      if (reachedRequiredLength && isMatchingDebounced) {
        renderedResults = this.renderLoader(debounceLoader, itemClassName, dropdownClassName);
      } else if (reachedRequiredLength && visible) {
        renderedResults = this.renderItems(currentInput, matchingItems, focusIndex, activeItemClassName, itemClassName, dropdownClassName);
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "datalist-input"
      }, this.renderInputField(placeholder, currentInput, inputClassName), renderedResults);
    }
  }]);

  return DataListInput;
}(React.Component);

DataListInput.defaultProps = {
  placeholder: '',
  match: undefined,
  inputClassName: '',
  dropdownClassName: '',
  itemClassName: '',
  activeItemClassName: '',
  requiredInputLength: 0,
  clearInputOnSelect: false,
  suppressReselect: true,
  dropDownLength: Infinity,
  initialValue: '',
  debounceTime: 0,
  debounceLoader: undefined,
  onDropdownOpen: function onDropdownOpen() {},
  onDropdownClose: function onDropdownClose() {},
  onInput: function onInput() {}
};
exports.default = DataListInput;